module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticClass: "one-content"
  }, [_c('content-title', {
    attrs: {
      "title": "模型参数设定"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setting-content"
  }, [_c('div', {
    staticClass: "model-setting"
  }, [_c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupsNum),
      callback: function($$v) {
        _vm.groupsNum = $$v
      },
      expression: "groupsNum"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("辆")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("每个群主最大客户数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.maxCustomersNum),
      callback: function($$v) {
        _vm.maxCustomersNum = $$v
      },
      expression: "maxCustomersNum"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("个")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆调度模型的TimeLimit")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupTimeLimit),
      callback: function($$v) {
        _vm.groupTimeLimit = $$v
      },
      expression: "groupTimeLimit"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("秒")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting"
  }, [_c('span', [_vm._v("车辆调度模型的MIPGap")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.groupMipGap),
      callback: function($$v) {
        _vm.groupMipGap = $$v
      },
      expression: "groupMipGap"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(" % ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "one-model-setting one-model-last"
  }, [_c('span', [_vm._v("路径规划模型的TimeLimit")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": _vm.solutionStatus > 20
    },
    model: {
      value: (_vm.routeTimeLimit),
      callback: function($$v) {
        _vm.routeTimeLimit = $$v
      },
      expression: "routeTimeLimit"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("秒")])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }, [_c('a', {
    staticClass: "show-note",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.show_note = !_vm.show_note
      }
    }
  }, [_vm._v(_vm._s(_vm.show_note ? '隐藏解析' : '显示解析'))])]), _vm._v(" "), _c('div', {
    staticClass: "setting-note"
  }, [(_vm.show_note) ? _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [
    [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.setting_note)
      }
    }), _vm._v(" "), _vm._l((_vm.notes), function(note) {
      return _c('li', [_vm._v(_vm._s(note))])
    })], 2)]
  ], 2) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "gu-duan"
  }), _vm._v(" "), _c('div', {
    staticClass: "two-content"
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('content-title', {
    attrs: {
      "title": "求解日期选择"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("该系统解决的是单日的配送问题，所以请选择所要查看配送安排的日期。")]), _vm._v(" "), _vm._l((_vm.solutionWeeks), function(week, index) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.solutionStatus > 20 ? null : _vm.solutionDay = index
        }
      }
    }, [(_vm.solutionDay === index) ? _c('img', {
      attrs: {
        "src": require("assets/checked-2.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.solutionDay !== index) ? _c('img', {
      attrs: {
        "src": require("assets/unchecked-2.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n            " + _vm._s(week) + "\n          ")])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "4em"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-1"
  }, [_c('content-title', {
    attrs: {
      "title": "求解器选择"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-content"
  }, _vm._l((_vm.solutionWays), function(type, index) {
    return _c('a', {
      staticClass: "checkbox-one",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.solutionStatus > 20 ? null : _vm.solutionWay = index
        }
      }
    }, [(_vm.solutionWay === index) ? _c('img', {
      attrs: {
        "src": require("assets/checked-2.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.solutionWay !== index) ? _c('img', {
      attrs: {
        "src": require("assets/unchecked-2.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "checkbox-label"
    }, [_vm._v("\n            " + _vm._s(type) + "\n          ")])])
  }))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ddbab28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/tobacco/setting_to.vue
// module id = 809
// module chunks = 1